import { render, staticRenderFns } from "./PublicationTableElement.vue?vue&type=template&id=152b940b&scoped=true&"
import script from "./PublicationTableElement.vue?vue&type=script&lang=js&"
export * from "./PublicationTableElement.vue?vue&type=script&lang=js&"
import style0 from "./PublicationTableElement.vue?vue&type=style&index=0&id=152b940b&scoped=true&lang=scss&"
import style1 from "./PublicationTableElement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b940b",
  null
  
)

export default component.exports